import { render, staticRenderFns } from "./AudioRecord.vue?vue&type=template&id=6dad41e2&scoped=true"
import script from "./AudioRecord.vue?vue&type=script&lang=js"
export * from "./AudioRecord.vue?vue&type=script&lang=js"
import style0 from "./AudioRecord.vue?vue&type=style&index=0&id=6dad41e2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dad41e2",
  null
  
)

export default component.exports